import { query } from '../utils/dom'
import Component from '../core/Component'

const STATES = {
    OPEN: 'is-open'
}

export default class ProductDetailDescription extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            content: null
        }
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        if (event.target.closest('a')) {
            return
        }
        event.preventDefault()
        this.toggle()
    }

    open() {
        if (this.is(STATES.OPEN)) {
            return
        }
        const textShortEl = query('[data-text-short]', this.element)
        const textLongEl = query('[data-text-long]', this.element)
        const fromHeight = textShortEl.offsetHeight
        const toHeight = textLongEl.offsetHeight

        this.unroll(fromHeight, toHeight)

        this.element.classList.add(STATES.OPEN)
        this.element.disabled = true
        this.element.tabIndex = -1
    }

    close() {
        if (!this.is(STATES.OPEN)) {
            return
        }
        const textShortEl = query('[data-text-short]', this.element)
        const textLongEl = query('[data-text-long]', this.element)
        const fromHeight = textLongEl.offsetHeight
        const toHeight = textShortEl.offsetHeight

        this.unroll(fromHeight, toHeight)

        this.element.classList.remove(STATES.OPEN)
        this.element.disabled = false
        this.element.tabIndex = 0
    }

    toggle() {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    unroll(fromHeight,toHeight) {
        const transitionEnd = () => {
            this.ref.content.removeEventListener('transitionend', transitionEnd)
            this.ref.content.style.height = ``
            this.ref.content.style.transition = ``
        }

        this.ref.content.addEventListener('transitionend', transitionEnd)
        this.ref.content.style.transition = `.3s height`
        this.ref.content.style.height = `${fromHeight}px`
        this.ref.content.offsetWidth
        this.ref.content.style.height = `${toHeight}px`
    }
}